import { lazy } from 'react';

const DecreePublicationDatesContainer = lazy(
  () => import('../containers/DecreePublicationDatesContainer'),
);

const DecreePublicationDatesRoute = () => <DecreePublicationDatesContainer />;

export default DecreePublicationDatesRoute;
